export const CompareValue = {
  taxCode: 'taxCode',
  phoneEmail: 'phoneEmail',
  phone: 'phone',
  email: 'email',
  password: 'password',
};

/**
 * Mixin xử lý validate text
 */
export const validateText = {
  validateRule(rule, value) {
    const me = this;
    let res = true;

    switch (rule) {
      case CompareValue.taxCode:
        res = me.validateTaxCode(value);
        break;
      case CompareValue.phoneEmail:
        res = me.validatePhoneEmail(value);
        break;
      case CompareValue.phone:
        res = me.validatePhone(value);
        break;
      case CompareValue.email:
        res = me.validateEmail(value);
        break;
      case CompareValue.password:
        res = me.validatePassword(value);
        break;
    }

    return res;
  },
  //Validate mã số thuế
  validateTaxCode(value) {
    try {
      let oRegex = /^[0-9]{10}$|^[0-9]{13}$|^[0-9]{10}(\s|-)[0-9]{3}$/;
      if (oRegex.test(value)) {
        let arrcode = [],
          lengthCode = value.length;
        for (let i = 0; i < lengthCode; i++) {
          arrcode.push(value[i]);
        }

        let intTemp =
          31 * parseFloat(arrcode[0]) +
          29 * parseFloat(arrcode[1]) +
          23 * parseFloat(arrcode[2]) +
          19 * parseFloat(arrcode[3]) +
          17 * parseFloat(arrcode[4]) +
          13 * parseFloat(arrcode[5]) +
          7 * parseFloat(arrcode[6]) +
          5 * parseFloat(arrcode[7]) +
          3 * parseFloat(arrcode[8]);

        if (!(parseFloat(arrcode[9]) === 10 - (intTemp % 11))) {
          return false;
        }
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
    return true;
  },
  validatePhoneEmail(value) {
    try {
      return this.validatePhone(value) || this.validateEmail(value);
    } catch (e) {
      return false;
    }
  },
  validatePhone(value) {
    if(!value) {
      return true;
    }
    try {
      let oRegex = /^(0|\+84)(\s|\.)?((3[2-9])|(5[689])|(7[06-9])|(8[1-689])|(9[0-46-9]))(\d)(\s|\.)?(\d{3})(\s|\.)?(\d{3})$/;
      let result = value;
      if (!oRegex.test(result.trim())) {
        return false;
      }
    } catch (e) {
      return false;
    }
    return true;
  },
  validateEmail(value) {
    try {
      let oRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let result = value;
      if (result && !oRegex.test(result.trim())) {
        return false;
      }
    } catch (e) {
      return false;
    }
    return true;
  },
  validatePassword(value) {
    const me = this;
    let lengthPass = false;
    if (value && value.length >= 8) {
      lengthPass = true;
    }
    let textPass = false;
    let upcasePass = false;
    let lowercasePass = false;
    if (value && /[^A-Z]/g.test(value)) {
      upcasePass = true;
    }
    if (value && /[^a-z]/g.test(value)) {
      lowercasePass = true;
    }
    if (upcasePass && lowercasePass) {
      textPass = true;
    }
    let numberPass = false;
    if (value && /[^0-9]/g.test(value)) {
      numberPass = true;
    }

    return lengthPass && textPass && numberPass;
  }
};
